<script lang="ts">
  import WorkOrderAppointmentTag from "../../../../../../../../../../../../../../_shared/_modules/work-order-appointment-tag"
  import type { AssignWorkOrderDraft, WorkOrderAssignmentRow } from "../../../../contract"
  import { workOrderAssignmentExistingAppointmentDisplay } from "../../../../_shared/_logic/01-assign-work-order-presentation"

  let {
    row,
    draft,
  }: {
    row: WorkOrderAssignmentRow
    draft: AssignWorkOrderDraft
  } = $props()

  const display = $derived(workOrderAssignmentExistingAppointmentDisplay(row, draft))
</script>

<WorkOrderAppointmentTag
  status={display.status}
  subLabel={display.subLabel}
  tooltipContent={display.tooltipContent}
  fallbackLabel={display.fallbackLabel}
  disabled={row.disabled}
/>
